var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0207 19.8437C4.60609 19.8437 0.197754 15.4354 0.197754 10.0208C0.197754 4.60621 4.60609 0.197876 10.0207 0.197876C15.4353 0.197876 19.8436 4.60621 19.8436 10.0208C19.8436 15.4354 15.4353 19.8437 10.0207 19.8437ZM10.0207 1.63538C5.39192 1.63538 1.63525 5.40163 1.63525 10.0208C1.63525 14.64 5.39192 18.4062 10.0207 18.4062C14.6494 18.4062 18.4061 14.64 18.4061 10.0208C18.4061 5.40163 14.6494 1.63538 10.0207 1.63538Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0832 20.802C19.9011 20.802 19.719 20.7349 19.5753 20.5912L17.6586 18.6745C17.3807 18.3966 17.3807 17.9366 17.6586 17.6587C17.9365 17.3807 18.3966 17.3807 18.6745 17.6587L20.5911 19.5753C20.8691 19.8532 20.8691 20.3132 20.5911 20.5912C20.4474 20.7349 20.2653 20.802 20.0832 20.802Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.258d435568048018a4ce907b34733a14.svg";
export { ForwardRef as ReactComponent };